import { Modal } from 'antd';

export interface ConfirmDeleteOptions {
  title: string;
  content: string;
  onOk: () => void | Promise<void>;
}

export function confirmDelete({
  title,
  content,
  onOk,
}: ConfirmDeleteOptions): void {
  Modal.confirm({
    title,
    content,
    okText: 'Delete',
    okType: 'danger',
    cancelText: 'Cancel',
    onOk,
  });
}
